import { ThemeColors } from '~/themes/colors'

interface FaxListItemColors {
  Statuses: {
    Default: ThemeColors
    Failed: ThemeColors
    Queued: ThemeColors
  }
  Thumbnail: {
    Border: ThemeColors
  }
  Popover: {
    Border: ThemeColors
    BoxShadow: ThemeColors
  }
  Skeleton: {
    StartColor: ThemeColors
    EndColor: ThemeColors
  }
  PendingAnim: {
    From: ThemeColors
    To: ThemeColors
  }
}

export const faxListItemColors: FaxListItemColors = {
  Statuses: {
    Default: {
      default: 'gray.1300',
    },
    Failed: {
      default: 'red.800',
    },
    Queued: {
      default: 'blue.800',
    },
  },
  Thumbnail: {
    Border: {
      default: 'gray.500',
    },
  },
  Popover: {
    Border: {
      default: 'gray.600',
    },
    BoxShadow: {
      default: `mask.gray.1300.20`,
    },
  },
  Skeleton: {
    StartColor: {
      default: 'mask.mango.blue.20',
    },
    EndColor: {
      default: 'achromatic.transparent',
    },
  },
  PendingAnim: {
    From: {
      default: 'blue.900',
    },
    To: {
      default: 'blue.500',
    },
  },
}
